import { useEffect, useRef, useState } from 'react';
import Button from "../../../Components/Button/Button";
import { Formik, Form, } from "formik";
import SelectCheckField from "../../../Components/SelectCheckField/SelectCheckField";
import Badge from "../../../Components/Badge/Badge";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import ChartsRadialBar from "../../../Components/ChartsRadialBar/ChartsRadialBar";
import Leyenda from '../../../Components/Leyenda/Leyenda';
import useLogin from '../../Autenticacion/Hooks/useLogin';
import { useComun } from '../../../Hooks/useComun';
import validations from '../../../Utils/Validations/Validations';
import { BuscaSerieIndicadorService } from '../Services/BuscaSerieIndicadorService';
import { EnumPathRutas, EnumParametro } from '../../../Utils/Enumeradores/ComunEnum';
import ColumnCharts from '../../../Components/ColumnCharts/ColumnCharts';
import notfound from '../../../Assets/images/il-empty.svg';
import { useRegistroTDR } from '../../../Hooks/useRegistroTDR';
import { ListaPeriodosCalculosService } from '../Services/ListaPeriodosCalculosService';
import ModalIspRecuerda from '../Components/ModalIspRecuerda';


const IndicadoresPage = () => {
	const { user, usuario } = useLogin();
	const { crearRegistroTDR } = useRegistroTDR();
	const formikRef = useRef();
	const {
		listaSerie,
		listaIndicadorDt,
		ObtenerListaSerie,
		ObtenerListaIndicadorDt,
		ParametroObtenerPorId,
		periodoConsultaIndicadores
	} = useComun();
	const [initialValues, setInitialValues] = useState({
		indicadoresSinValidacion: '',
		serie: [1],
		historico: []
	});
	const [listadoHistorico, setListadoHistorico] = useState([]);
	const [dataSerieIndicador, setDataSerieIndicador] = useState([]);
	const [dataSerieNivelServicio, setDataSerieNivelServicio] = useState([]);
	const [dataSerieIndicadorCompleto, setDataSerieIndicadorCompleto] = useState([]);
	const [listaSerieTab, setListaSerieTab] = useState([{ serie: 1, clase: 'secondary' }]);
	const [listaHistoricoTab, setListaHistoricoTab] = useState([]);
	const [descripcionNivelServicio, setDescripcionNivelServicio] = useState(null);
	const [mostrarGrafico, setMostrarGrafico] = useState(false);
	const navigate = useNavigate();
	const [conDatos, setConDatos] = useState(false);
	const [tdrIdCounter, setTdrIdCounter] = useState(4);
	const [selectedSerieId, setSelectedSerieId] = useState(null);
	const [showModalIspRecuerda, setShowModalIspRecuerda] = useState(false);
	const [historicosSinDatos, setHistoricosSinDatos] = useState(new Set());
	const [modoVista, setModoVista] = useState('nivelServicio');
	const [graficoVersion, setGraficoVersion] = useState(0);
	const maxPeriodosGrafico = Number(periodoConsultaIndicadores) || 3;

	const [datosGrafico, setDatosGrafico] = useState({
		listaNombres: [],
		listaData: []
	});

	const mapPeriodosHistoricos = (periodos = []) => {
		const periodosAgrupados = periodos.reduce((acumulado, item) => {
			if (!acumulado[item.ano]) {
				acumulado[item.ano] = [];
			}

			acumulado[item.ano].push({
				value: `${item.ano}-${String(item.mes).padStart(2, '0')}`,
				label: item.nombreMes,
				mes: item.mes
			});

			return acumulado;
		}, {});

		return Object.keys(periodosAgrupados)
			.sort((a, b) => Number(b) - Number(a))
			.map((ano) => ({
				label: ano,
				options: periodosAgrupados[ano].sort((a, b) => a.mes - b.mes)
			}));
	};

	const ObtenerListaPeriodosHistorico = async () => {
		const resp = await ListaPeriodosCalculosService({ idUsuario: user.id });
		if (resp && resp.status === 200 && Array.isArray(resp.data)) {
			const listado = mapPeriodosHistoricos(resp.data);
			setListadoHistorico(listado);
		}
	};

	const getHistoricoLabel = (historicoValue) => {
		for (const grupo of listadoHistorico) {
			const item = (grupo.options || []).find((opt) => opt.value === historicoValue);
			if (item) {
				return `${grupo.label} ${item.label}`;
			}
		}

		return historicoValue;
	};

	const getPeriodosHistoricosPayload = (historicos = []) => {
		const historicosNormalizados = Array.isArray(historicos)
			? historicos
			: historicos ? [historicos] : [];

		return historicosNormalizados.filter(Boolean).map((item) => String(item));
	};

	const getTotalSeleccionadosGrafico = (series = [], historicos = []) => {
		return [...series, ...historicos].filter((item) => item?.clase === 'secondary').length;
	};

	const aplicarSeleccionInicialGrafico = (seriesSeleccionadas = [], historicosSeleccionados = []) => {
		const total = seriesSeleccionadas.length + historicosSeleccionados.length;
		const limite = maxPeriodosGrafico > 0 ? Math.min(maxPeriodosGrafico, total) : total;
		let restantes = limite;

		const seriesTab = seriesSeleccionadas.map((serieValue) => {
			const seleccionar = restantes > 0;
			if (seleccionar) {
				restantes -= 1;
			}

			return { serie: serieValue, clase: seleccionar ? 'secondary' : 'gray' };
		});

		const historicoTab = historicosSeleccionados.map((historicoValue) => {
			const seleccionar = restantes > 0;
			if (seleccionar) {
				restantes -= 1;
			}

			return {
				value: historicoValue,
				label: getHistoricoLabel(historicoValue),
				clase: seleccionar ? 'secondary' : 'gray'
			};
		});

		return { seriesTab, historicoTab };
	};

	const toggleSerieGrafico = (serieId) => {
		const serieObjetivo = listaSerieTab.find((item) => item?.serie === serieId);
		const totalSeleccionados = getTotalSeleccionadosGrafico(listaSerieTab, listaHistoricoTab);

		if (serieObjetivo && serieObjetivo.clase !== 'secondary' && maxPeriodosGrafico > 0 && totalSeleccionados >= maxPeriodosGrafico) {
			setShowModalIspRecuerda(true);
			return;
		}

		setListaSerieTab((prev) => prev.map((item) => {
			if (!item || item.serie !== serieId) {
				return item;
			}

			if (item.clase === 'secondary') {
				return { ...item, clase: 'gray' };
			}

			return { ...item, clase: 'secondary' };
		}));
	};

	const toggleHistoricoGrafico = (historicoValue) => {
		const historicoObjetivo = listaHistoricoTab.find((item) => item?.value === historicoValue);
		const totalSeleccionados = getTotalSeleccionadosGrafico(listaSerieTab, listaHistoricoTab);

		if (historicoObjetivo && historicoObjetivo.clase !== 'secondary' && maxPeriodosGrafico > 0 && totalSeleccionados >= maxPeriodosGrafico) {
			setShowModalIspRecuerda(true);
			return;
		}

		setListaHistoricoTab((prev) => prev.map((item) => {
			if (!item || item.value !== historicoValue) {
				return item;
			}

			if (item.clase === 'secondary') {
				return { ...item, clase: 'gray' };
			}

			return { ...item, clase: 'secondary' };
		}));
	};

	useEffect(() => {
		//const startTime = new Date();
		if (dataSerieIndicador.length > 0) {
			const listaNombres = dataSerieIndicador
				.sort((a, b) => a.indicadorId > b.indicadorId ? 1 : -1)
				.map(x => x.sigla);

			if (!mostrarGrafico) return;

			const seriesActivas = new Set(
				listaSerieTab
					.filter((item) => item?.clase === 'secondary')
					.map((item) => item.serie)
			);

			const historicosActivos = new Set(
				listaHistoricoTab
					.filter((item) => item?.clase === 'secondary')
					.map((item) => item.label)
			);

			const fuenteDatos = mostrarGrafico
				? dataSerieIndicadorCompleto.filter((item) =>
					seriesActivas.has(item.serieId) || historicosActivos.has(item.serieDescripcion)
				)
				: dataSerieIndicadorCompleto;

			if (mostrarGrafico && fuenteDatos.length === 0) {
				setConDatos(false);
				setDatosGrafico({ listaNombres: [], listaData: [] });
			} else {
				const listaDatos = fuenteDatos.map((item) => {
					const listaValor = item.indicador
						.filter((indicador) => listaNombres.some((sigla) => sigla === indicador.sigla))
						.sort((a, b) => a.indicadorId > b.indicadorId ? 1 : -1)
						.map((indicador) => ((indicador.sigla === 'AT' || indicador.sigla === 'ATO')
							? indicador.valorCumplimiento
							: indicador.valor));

					return { name: item.serieDescripcion, data: listaValor };
				});

				setDatosGrafico({ listaNombres: listaNombres, listaData: listaDatos });
				setConDatos(true);
			}
		}
	}, [dataSerieIndicador, dataSerieIndicadorCompleto, listaSerieTab, listaHistoricoTab, mostrarGrafico])

	useEffect(() => {
		if (dataSerieIndicadorCompleto.length > 0 && listaHistoricoTab.length > 0) {
			const sinDatos = new Set();
			listaHistoricoTab.forEach(item => {
				const tieneDatos = dataSerieIndicadorCompleto.some(
					dataItem => dataItem.serieDescripcion === item.label
				);
				if (!tieneDatos) {
					sinDatos.add(item.value);
				}
			});
			setHistoricosSinDatos(sinDatos);
		} else {
			setHistoricosSinDatos(new Set());
		}
	}, [dataSerieIndicadorCompleto, listaHistoricoTab])

	async function postBuscaSerieIndicador(values, esNivelServicio = true, selectedBuscar1 = false) {
    const resp = await BuscaSerieIndicadorService(values);
    if (resp) {
        if (resp.status === 200) {
            if (resp.data) {
                setDescripcionNivelServicio(null);
                setDataSerieIndicadorCompleto(resp.data);
                if (resp.data.length > 0) {
									const serieSeleccionada = selectedBuscar1 == true ? resp.data[0] : resp.data.find(x => x.serieId === selectedSerieId) || resp.data[0];
                    if (esNivelServicio) {
                        setModoVista('nivelServicio');
                        setDataSerieNivelServicio(serieSeleccionada.indicador.sort((a, b) => a.indicadorId > b.indicadorId ? 1 : -1));
                        setDataSerieIndicador([]);
                    } else {
                        setModoVista('indicador');
                        setDataSerieNivelServicio([]);
                        const tieneHijo = serieSeleccionada.indicador.filter(x => x.indicadorHijo.length > 0);
                        if (tieneHijo.length > 0) {
                            setDescripcionNivelServicio(tieneHijo[0]);
                            setDataSerieIndicador(tieneHijo[0].indicadorHijo.sort((a, b) => a.indicadorId > b.indicadorId ? 1 : -1));
                        } else {
                            setDataSerieIndicador(serieSeleccionada.indicador.sort((a, b) => a.indicadorId > b.indicadorId ? 1 : -1));
                        }
                    }
                }
                setConDatos(true);
            }
        } else if (resp.status === 206) {
            setConDatos(false);
        }
    }
}

	useEffect(() => {
		const startTime = new Date();
		const formEnvio = {
			idUsuario: user.id,
			idPerfilContexto: usuario.perfilContexto.id
		}

		const formEnvioBuscar = {
			idUsuario: user.id,
			indicadorId: [2, 3, 4],
			serieId: initialValues.serie,
			idPerfilContexto: usuario.perfilContexto.id,
			periodosHistoricos: [],
			consultaIndicadores: false
		}


		const fetchData = async () => {
			await Promise.all([
				ObtenerListaSerie(formEnvio),
				ObtenerListaIndicadorDt(formEnvio),
				ParametroObtenerPorId(EnumParametro.PeriodoConsultaIndicadores),
				ObtenerListaPeriodosHistorico(),
				postBuscaSerieIndicador(formEnvioBuscar)
			]);
			const endTime = new Date();
			const tdrId = 3;
			crearRegistroTDR(startTime, endTime, usuario, tdrId);
		};

		fetchData();
	}, [])

	function SubmitBuscarSerieIndicador(values) {

		const startTime = new Date();
		const formEnvio = {
			idUsuario: usuario.id,
			indicadorId: (values.indicadoresSinValidacion.length === 0) ? [2, 3, 4] : values.indicadoresSinValidacion,
			serieId: values.serie,
			idPerfilContexto: usuario.perfilContexto.id,
			periodosHistoricos: getPeriodosHistoricosPayload(values.historico),
			consultaIndicadores: true
		}
		const fetchData = async () => {
			await Promise.all([

				postBuscaSerieIndicador(formEnvio, (values.indicadoresSinValidacion.length === 0) ? true : false, true)
			]);
			const endTime = new Date();
			const tdrId = 10;
			crearRegistroTDR(startTime, endTime, usuario, tdrId);
		};
		fetchData();

		const seriesSeleccionadas = Array.isArray(values.serie)
			? values.serie
			: values.serie ? [values.serie] : [];

		const historicosSeleccionados = Array.isArray(values.historico)
			? values.historico
			: values.historico ? [values.historico] : [];

		const tieneSerieSeleccionada = seriesSeleccionadas.length > 0;
		const primerHistorico = historicosSeleccionados[0];
		setListaHistoricoTab(historicosSeleccionados.map((historicoValue) => ({
			value: historicoValue,
			label: getHistoricoLabel(historicoValue),
			clase: !tieneSerieSeleccionada && historicoValue === primerHistorico ? 'secondary' : 'gray'
		})));

		if (seriesSeleccionadas.length > 0) {
			const numeroMin = seriesSeleccionadas.reduce((n, m) => Math.min(n, m), Number.POSITIVE_INFINITY);
			setListaSerieTab(seriesSeleccionadas.map((x) => {
				if (x === numeroMin) {
					return { serie: numeroMin, clase: 'secondary' }
				}

				return { serie: x, clase: 'gray' }
			}));
		} else {
			setListaSerieTab([]);
		}

		//CUANDO HACE BUSQUEDA PARA LOS NIVELES DE SERVICIO Y ESTABA EN LA VISTA DEL GRAFICO, CIERRA EL GRAFICO Y SE LISTAN NUEVAMENTE LAS SERIES
		if (values.indicadoresSinValidacion.length === 0) {
			setMostrarGrafico(false);
			if (seriesSeleccionadas.length > 0) {
				const numeroMin = seriesSeleccionadas.reduce((n, m) => Math.min(n, m), Number.POSITIVE_INFINITY);
				setListaSerieTab(seriesSeleccionadas.map(x => {
					if (x === numeroMin) {
						return { serie: numeroMin, clase: 'secondary' }
					} else {
						return { serie: x, clase: 'gray' }
					}
				}));
			} else {
				setListaSerieTab([]);
			}
		} else if (mostrarGrafico) { // CUANDO ES MOSTRAR GRAFICO DEJA LAS SERIES EN GRIS SIN BOTON
			setListaSerieTab(seriesSeleccionadas.map(x => {
				return { serie: x, clase: 'gray' }
			}));
		} else {//LISTA LAS SERIES PINTANDO LA SERIE MINIMA
			if (seriesSeleccionadas.length > 0) {
				const numeroMin = seriesSeleccionadas.reduce((n, m) => Math.min(n, m), Number.POSITIVE_INFINITY);
				setListaSerieTab(seriesSeleccionadas.map(x => {
					if (x === numeroMin) {
						return { serie: numeroMin, clase: 'secondary' }
					} else {
						return { serie: x, clase: 'gray' }
					}
				}));
			} else {
				setListaSerieTab([]);
			}
		}

	}
	function changeMostrarGrafico(esMostrar) {
		const startTime = new Date();
		if (esMostrar) {
			setGraficoVersion(prev => prev + 1);
			const seriesSeleccionadas = Array.isArray(formikRef.current?.values?.serie)
				? formikRef.current.values.serie
				: formikRef.current?.values?.serie ? [formikRef.current.values.serie] : [];

			const historicosSeleccionados = Array.isArray(formikRef.current?.values?.historico)
				? formikRef.current.values.historico
				: formikRef.current?.values?.historico ? [formikRef.current.values.historico] : [];

			const { seriesTab, historicoTab } = aplicarSeleccionInicialGrafico(seriesSeleccionadas, historicosSeleccionados);
			setListaSerieTab(seriesTab);
			setListaHistoricoTab(historicoTab);

			const fetchData = async () => {
				await Promise.all([]);
				const endTime = new Date();
				const tdrId = 11;
				crearRegistroTDR(startTime, endTime, usuario, tdrId);
			};

			fetchData();
		} else {
			if (listaSerieTab.length > 0) {
				const numeroMin = listaSerieTab.reduce((n, m) => Math.min(n, m.serie), Number.POSITIVE_INFINITY);
				changeSerie(numeroMin);
			}
		}
		setMostrarGrafico(esMostrar);
	}

	function changeHistorico(historicoValue) {
		setListaSerieTab(
			listaSerieTab.map(x => {
				return { ...x, clase: 'gray' }
			})
		);

		setListaHistoricoTab(
			listaHistoricoTab.map(x => {
				if (x.value === historicoValue) {
					return { ...x, clase: 'secondary' }
				}

				return { ...x, clase: 'gray' }
			})
		);

		const historicoSeleccionado = listaHistoricoTab.find((item) => item?.value === historicoValue);
		const descripcionHistorico = historicoSeleccionado?.label || getHistoricoLabel(historicoValue);
		const lista = dataSerieIndicadorCompleto.filter((item) => item.serieDescripcion === descripcionHistorico);
		const serieSeleccionada = lista.length > 0 ? lista[0] : null;

		if (!serieSeleccionada) {
			setDataSerieNivelServicio([]);
			setDataSerieIndicador([]);
			setDescripcionNivelServicio(null);
			setConDatos(false);
			return;
		}

		setConDatos(true);
		setSelectedSerieId(null);
		if (modoVista === 'nivelServicio') {
			setDataSerieNivelServicio(serieSeleccionada.indicador.sort((a, b) => a.indicadorId > b.indicadorId ? 1 : -1));
		}
		if (modoVista === 'indicador') {
			const tieneHijo = serieSeleccionada.indicador.filter(x => x.indicadorHijo.length > 0);
			if (tieneHijo.length > 0) {
				setDescripcionNivelServicio(tieneHijo[0]);
				setDataSerieIndicador(tieneHijo[0].indicadorHijo.sort((a, b) => a.indicadorId > b.indicadorId ? 1 : -1));
			} else {
				setDescripcionNivelServicio(null);
				setDataSerieIndicador(serieSeleccionada.indicador.sort((a, b) => a.indicadorId > b.indicadorId ? 1 : -1));
			}
		}
	}

	function changeSerie(serieId) {
		setListaHistoricoTab(
			listaHistoricoTab.map(x => {
				return { ...x, clase: 'gray' }
			})
		);

		setListaSerieTab(
			listaSerieTab.map(x => {
				if (x.serie === serieId) {
					return { serie: serieId, clase: 'secondary' }
				} else {
					return { serie: x.serie, clase: 'gray' }
				}
			})

		);
		const lista = dataSerieIndicadorCompleto.filter(x => x.serieId === serieId);
		setSelectedSerieId(serieId);
		if (modoVista === 'nivelServicio') {
			setDataSerieNivelServicio(lista.length > 0 ? lista[0].indicador.sort((a, b) => a.indicadorId > b.indicadorId ? 1 : -1) : []);
		}
		if (modoVista === 'indicador') {
			if (lista.length > 0) {
				const tieneHijo = lista[0].indicador.filter(x => x.indicadorHijo.length > 0);
				if (tieneHijo.length > 0) {
					setDescripcionNivelServicio(tieneHijo[0]);
					setDataSerieIndicador(tieneHijo[0].indicadorHijo.sort((a, b) => a.indicadorId > b.indicadorId ? 1 : -1));
				} else {
					setDescripcionNivelServicio(null);
					setDataSerieIndicador(lista[0].indicador.sort((a, b) => a.indicadorId > b.indicadorId ? 1 : -1));
				}
			} else {
				setDescripcionNivelServicio(null);
				setDataSerieIndicador([]);
			}
		}
	}



	const maxTdrId = 7; // Termina en 7

	function mostrarIndicadores(x) {
    if (x.esNivelServicio) {
        const formEnvio = {
            idUsuario: usuario.id,
            indicadorId: [x.indicadorId],
            serieId: formikRef.current.values.serie,
            idPerfilContexto: usuario.perfilContexto.id,
            consultaIndicadores: true
        };
        const startTime = new Date(); // Inicia el contador
        const fetchData = async () => {
            await Promise.all([
                postBuscaSerieIndicador(formEnvio, false)
            ]);
            const endTime = new Date();
            crearRegistroTDR(startTime, endTime, usuario, tdrIdCounter);
            // Almacenar el valor actualizado de tdrIdCounter en el almacenamiento local
            localStorage.setItem('tdrIdCounter', tdrIdCounter);
            setTdrIdCounter(prevCounter => {
                const newCounter = prevCounter + 1;
                if (newCounter > maxTdrId) { // Si supera el máximo, reinicia
                    return 3;
                }
                return newCounter;
            });
        };
        fetchData();
    } else {
        navigate("cuarto-nivel", { state: { idNivelCumplimiento: x.nivelCumplimientoId, item: x } });
    }
}



	const serieSeleccionadaActiva = listaSerieTab.find((x) => x?.clase === 'secondary');

	return (
		<div className="container-fluid h-100">
			<div className="row mb-4">
				<div className="col-12">
					<div className="breadcrumbs">
						<ul>
							<li><Link to={EnumPathRutas.Inicio}> Inicio</Link></li>
							<li><a href="" onClick={(e) => { e.preventDefault(); window.location.reload(false); }}>Indicadores</a></li>
							<li><a href="">Nivel de servicio</a></li>
						</ul>
					</div>
				</div>
			</div>
			<div className="row h-100">
				<div className="col-12">
					<div className="bg-white rounded p-4">
						<div className="d-flex flex-column justify-content-between mb-5 gap-4">
							<div className="d-flex flex-column flex-md-row gap-3 justify-content-between indicadores-toolbar">
								<Formik
									innerRef={formikRef}
									enableReinitialize
									initialValues={initialValues}
									validate={validations}
									onSubmit={values => {
										SubmitBuscarSerieIndicador(values);
									}}
								>
									{({ values, setFieldValue, errors, setFieldTouched, touched }) => (
										<Form className="form flex-wrap flex-row mb-0 order-1 order-md-0 indicadores-toolbar-form">
											<SelectCheckField
												name="indicadoresSinValidacion"
												label="Indicadores"
												options={listaIndicadorDt}
												onChange={setFieldValue}
												onBlur={setFieldTouched}
												isMulti={true}
											/>
											<SelectCheckField
												name="serie"
												label="Periodo"
												options={listaSerie}
												onChange={setFieldValue}
												onBlur={setFieldTouched}
												isMulti={true}
											/>
											<div className="d-flex flex-column">
												<SelectCheckField
													name="historico"
													label="Histórico"
													options={listadoHistorico}
													onChange={setFieldValue}
													onBlur={setFieldTouched}
													treeMode={true}
													isMulti={true}
												/>
												{/* <small className="text-pewter-blue mt-1 ps-1">
													Periodo consulta indicadores: {periodoConsultaIndicadores ?? 'Sin valor'}
												</small> */}
											</div>
											<div className="d-flex flex-column flex-md-row justify-content-center align-items-stretch gap-4">
												<Button type="submit" design="btn-primary align-self-normal" style={{ maxHeight: '48px' }}>Buscar</Button>
											</div>
										</Form>
									)}
								</Formik>
								{
									dataSerieIndicador.length !== 0 && descripcionNivelServicio === null &&
									<>
										{!mostrarGrafico ?
											<button className='btn btn--icon btn--gray btn--pewter-blue br-sm align-self-end align-self-md-start order-0 order-md-1' onClick={() => changeMostrarGrafico(true)}>
												<i className='ico ico-graph-bar'></i>
											</button>
											:
											<div className='indicadores-accion-group align-self-end align-self-md-start order-0 order-md-1'>
												{/* <button type='button' className='btn btn--icon btn--gray btn--pewter-blue br-sm' aria-label='Exportar a Excel'>
													<i className='ico-file-excel'></i>
												</button>
												<span className='indicadores-accion-divider' aria-hidden='true'></span> */}
												<button className='btn btn--icon btn--gray btn--pewter-blue br-sm' onClick={() => changeMostrarGrafico(false)}>
													<i className='ico ico-analytics'></i>
												</button>
											</div>
										}
									</>
								}

							</div>
							<div className="d-flex order-0 order-lg-1 gap-3 flex-wrap">
								{mostrarGrafico ?
									<>
										<div className="w-100 text-pewter-blue mb-2">
											Selecciona máximo {maxPeriodosGrafico} periodos
										</div>
										{listaSerieTab.filter(Boolean).map((x, i) => {
											return (
												<Badge
													key={i}
													design={x.clase}
													className="mb-3 d-inline-flex align-items-center gap-2"
												>
													<input
														type="checkbox"
														className="form-check-input m-0"
														checked={x.clase === 'secondary'}

														onChange={() => toggleSerieGrafico(x.serie)}
													/>
													<span>
														{listaSerie.map(y => {
															if (y.value === x.serie) {
																return y.label
															}
														})}
													</span>
												</Badge>
											)
										})}
									</>
									:
									listaSerieTab.filter(Boolean).map((x, i) => {
										return (
											<Badge
												key={i}
												design={x.clase}
												className="mb-3"
												onClick={(e) => { changeSerie(x.serie) }}
											>{listaSerie.map(y => {
												if (y.value === x.serie) {
													return y.label
												}
											})}</Badge>
										)
									})
								}
								{listaHistoricoTab.filter(Boolean).map((item, i) => {
									const esDeshabilitado = historicosSinDatos.has(item.value);
									if (mostrarGrafico) {
										const badge = (
											<Badge
												key={`historico-${item.value}-${i}`}
												design={esDeshabilitado ? 'gray' : (item.clase || 'gray')}
												className={`mb-3 d-inline-flex align-items-center gap-2 ${esDeshabilitado ? 'badge--disabled' : ''}`}
											>
												<input
													type="checkbox"
													className="form-check-input m-0 cursor-pointer"
													checked={item.clase === 'secondary'}
													disabled={esDeshabilitado}
													onChange={() => toggleHistoricoGrafico(item.value)}
												/>
												<span className='cursor-default'>{item.label}</span>
											</Badge>
										);

										if (esDeshabilitado) {
											return (
												<OverlayTrigger
													key={`tooltip-hist-${item.value}-${i}`}
													placement="top"
													overlay={<Tooltip id="tooltip-top">Sin información disponible</Tooltip>}
												>
													<span className="d-inline-flex">{badge}</span>
												</OverlayTrigger>
											);
										}

										return badge;
									}

								const badge = (
									<Badge
										key={`historico-${item.value}-${i}`}
										design={item.clase || 'gray'}
										className={`mb-3 d-inline-flex align-items-center gap-2 cursor-pointer ${esDeshabilitado ? 'badge--disabled' : ''}`}
										onClick={() => { changeHistorico(item.value) }}
									>
										{item.label}
									</Badge>
								);

								if (esDeshabilitado) {
										return (
											<OverlayTrigger
												key={`tooltip-hist-${item.value}-${i}`}
												placement="top"
												overlay={<Tooltip id="tooltip-top">Sin información disponible</Tooltip>}
											>
												<span className="d-inline-flex">{badge}</span>
											</OverlayTrigger>
										);
									}

									return badge;
								})}

							</div>
						</div>
						{
							conDatos ?
								!mostrarGrafico ?
									<>
										{descripcionNivelServicio !== null &&
											<div className="d-flex align-items-end mb-4 gap-2">
												<span className='d-flex flex-column'>
													<h3 className="fs-3">{descripcionNivelServicio.sigla}</h3>
													<span className="text-pewter-blue d-block">{descripcionNivelServicio.descripcion}</span>
												</span>
												<div className="legend__item legend__item--success fs-1 lh-1">
													<span className="legend__value">{descripcionNivelServicio.valor}%</span>
													<span className="legend__indicator">
														<i className="ico-increase"></i>
													</span>
												</div>
											</div>
										}


										< div className="row">
											{
												dataSerieNivelServicio.map((x, i) => {
													return (
														i === 0 &&
														<div key={i} className="col-12 col-md-6 mb-4 mb-md-0">
															<div className="border p-4 rounded h-100 d-flex flex-column justify-content-between">
																<div className="d-flex justify-content-between align-items-center mb-4">
																	<span>
																		<h3 className="fs-3">{x.sigla}</h3>
																		<span className="text-pewter-blue d-block">{x.descripcion}</span>
																	</span>
																	<span onClick={(e) => mostrarIndicadores(x)} className="btn btn--outline btn--icon btn--pewter-blue align-self-end">
																		<i className="ico-chevron-right"></i>
																	</span>

																</div>
																{
																	x.valorCumplimiento ?
																		<>
																			<ChartsRadialBar
																				size="400"
																				bezel="75"
																				dataChart={{ serie: x.valorCumplimiento ? x.valorCumplimiento : 0, color: x.colorCumplimiento }}
																			/>
																			<Leyenda className="flex-row align-self-center flex-wrap justify-content-center" indicators={x.indicadorHijo.map(x => x = { ...x, state: x.cumple ? "success" : "danger" })} esLogicaIndicador={true} />
																		</>
																		:
																		<div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
																			<img className="mb-3" src={notfound} alt="" />
																			<p className='mb-0 text-primary'>Información no disponible.</p>
																		</div>
																}
																<div></div>
																{ }

															</div>
														</div>
													)
												})
											}
											{
												dataSerieNivelServicio.length > 0 &&
												<div className="col-12 col-md-6 mb-4 mb-md-0">
													{
														dataSerieNivelServicio.map((x, i) => {
															return (
																i !== 0 &&
																<div key={i} className={`border p-4 rounded ${i === 1 ? 'mb-4' : ''}`}>
																	<div className="d-flex justify-content-between align-items-center mb-4">
																		<span>
																			<h3 className="fs-3">{x.sigla}</h3>
																			<span className="text-pewter-blue d-block">{x.descripcion}</span>
																		</span>
																		<span onClick={(e) => mostrarIndicadores(x)} className="btn btn--outline btn--icon btn--pewter-blue align-self-end">
																			<i className="ico-chevron-right"></i>
																		</span>

																	</div>
																	<div className='d-flex justify-content-center flex-wrap'>
																		{
																			x.valorCumplimiento ?
																				<div className='align-self-end order-1 order-xl-0'>
																					<Leyenda indicators={x.indicadorHijo.map(x => x = { ...x, state: x.cumple ? "success" : "danger" })} esLogicaIndicador={true} />
																				</div>
																				: null
																		}
																		<div className='order-0 order-xl-1'>
																			{
																				x.valorCumplimiento ?
																					<ChartsRadialBar
																						size="230"
																						dataChart={{ serie: x.valorCumplimiento ? x.valorCumplimiento : 0, color: x.colorCumplimiento }}
																					/>
																					:
																					<div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
																						<img className="mb-3" src={notfound} alt="" />
																						<p className='mb-0 text-primary'>Información no disponible.</p>
																					</div>
																			}
																		</div>
																	</div>
																</div>

															)
														})
													}


												</div>
											}


											{
												dataSerieIndicador.map((x, i) => {
													return (
														<div key={i} className="col-12 col-md-4 mb-4">
															<div className="border p-4 rounded d-flex flex-column justify-content-start">
																<div className="d-flex justify-content-between align-items-center mb-4 mb-5">
																	<span>
																		<h3 className="fs-3">{x.sigla}</h3>
																		<span className="text-pewter-blue d-block">{x.descripcion}</span>
																	</span>
																	<span onClick={(e) => mostrarIndicadores(x)} className="btn btn--outline btn--icon btn--pewter-blue align-self-end">
																		<i className="ico-chevron-right"></i>
																	</span>
																</div>
																<div className='d-flex flex-column gap-5'>
																	<ChartsRadialBar
																		size="250"
																		dataChart={{ serie: x.valorCumplimiento, color: x.colorCumplimiento }}
																	/>
																	{serieSeleccionadaActiva?.serie > 5 && (x.sigla === "AT" || x.sigla === "ATO")?
																		<div className="text-center">
																		<div className={`legend `}>
																			<div className={`legend__item legend__item--`}>
																				<span className="legend__label"> &nbsp;</span>
																			</div>
																		</div>
																	</div>

																	:
																		<div className="text-center">
																			<div className={`legend `}>
																				<div className={`legend__item legend__item--`}>
																					<span className="legend__dot" style={{ backgroundColor: x.colorCumplimiento, borderColor: 'rgba(255, 255, 255, 0.8)' }}></span>
																					<span className="legend__label">{x.valorIndicador}</span>
																				</div>
																			</div>
																		</div>
																	}
																</div>
															</div>
														</div>
													);
												})
											}


										</div>
									</>
									:
									<div className="row" style={{ height: 'calc(100% - 140px)' }}>
										<div className="col-12">
											<div className="border rounded p-4 h-100">
												<ColumnCharts
													key={graficoVersion}
													dataChart={datosGrafico}
												/>
											</div>
										</div>
									</div>
								:
								<div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
									<img className="mb-3" src={notfound} alt="" />
									<p className='mb-0 text-primary'>Información no disponible.</p>
								</div>
						}
					</div>
				</div>
				<ModalIspRecuerda
					show={showModalIspRecuerda}
					onHide={() => setShowModalIspRecuerda(false)}
					maxPeriodos={maxPeriodosGrafico}
				/>
			</div>
		</div>
	)
}
export default IndicadoresPage;
